import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SELECT_QUANTITY } from '../../../brands/default/constants';
import { getSelectValues } from '../../../helpers/checkout';
import { symbolFromCurrency } from '../../../helpers/currency';
import { replaceImageServer } from '../../../helpers/image';
import ThemeContext from '../../../providers/ThemeProvider';
import { updateCheckoutData } from '../../../redux/actions/checkout';
import { basketAddOns } from '../../../services/basket';
import PrimaryButton from '../../_generic/button/PrimaryButton';
import CustomNativeSelect from '../../_generic/custom-native-select/CustomNativeSelect';
import useToast from '../../_generic/toast/UseToast';

const VoucherValidityItem = ({ bt, vveExtensionItem }) => {
  const theme = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [isUpdated, setIsUpdated] = useState(true);
  const price = `${symbolFromCurrency(
    vveExtensionItem?.extensionPrice?.currency,
  )}${vveExtensionItem?.extensionPrice?.amount}`;
  const [buyButtonText, setBuyButtonText] = useState(
    isUpdated ? 'ADD' : 'Remove',
  );
  const toast = useToast();
  const productId = vveExtensionItem?.dealProductId;
  const UpdatedMessage = 'Your basket has been updated.';
  const values = getSelectValues(0, vveExtensionItem?.quantity);

  const displayQuantity = vveExtensionItem?.userSelectedQuantity;
  const [selectedValue, setSelectedValue] = useState(
    displayQuantity > 0
      ? displayQuantity
      : values.length > 0
      ? values[values.length - 1]
      : 0,
  );

  const imagePath = replaceImageServer({
    dealId: vveExtensionItem?.dealVoucherId,
    image: vveExtensionItem?.productImage || vveExtensionItem?.dealImage,
  });

  const handleBuyButtonClick = async () => {
    try {
      await basketAddOns(bt, productId, selectedValue);
      setIsUpdated(true);
      dispatch(updateCheckoutData(bt));
      toast.addToast(UpdatedMessage, 'toast-success');
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleChange = (event) => {
    setSelectedValue(Number(event.target.value));
    if (vveExtensionItem?.quantity === Number(event.target.value))
      setBuyButtonText('ADD');
    else setBuyButtonText('Update');
  };

  const isButtonDisabled =
    (selectedValue === 0 && vveExtensionItem?.userSelectedQuantity === 0) ||
    (selectedValue === vveExtensionItem?.userSelectedQuantity &&
      isUpdated === true);

  const rawPrice = Number.parseFloat(price.replace(/[^\d.]/g, ''));
  const displayPrice = `${symbolFromCurrency(
    vveExtensionItem?.extensionPrice?.currency,
  )}${(rawPrice * selectedValue).toFixed(2)}`;

  return (
    <>
      <div className="item">
        <div className="item-line">
          <div className="wrapper">
            <div className="img-container">
              <img
                alt="Voucher"
                className="object-cover"
                height={90}
                src={imagePath}
                width={120}
              />
            </div>
            <div className="title-col">
              <h4 className="title">{vveExtensionItem?.voucherTitle}</h4>
              <p className="date">
                Extend until {vveExtensionItem?.extensionDate}
              </p>
            </div>
          </div>
          <div className="price-col">
            <div className="price-row">
              <div className="quantity-container">
                <div className="quantity-label">Quantity</div>
                <CustomNativeSelect
                  ariaLabel={SELECT_QUANTITY}
                  className="quantity__select"
                  onChange={handleChange}
                  value={selectedValue}
                >
                  {values.map((value) => (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  ))}
                </CustomNativeSelect>
              </div>
              <div className="sub-container">
                <div className="sub-label">Subtotal</div>
                <div className="sub-total">{displayPrice}</div>
              </div>
            </div>
            <p className="buy-button">
              <PrimaryButton
                className="size-small inline"
                disabled={isButtonDisabled}
                id="extend-validity-button-buy"
                onClick={handleBuyButtonClick}
              >
                {buyButtonText}
              </PrimaryButton>
            </p>
          </div>
        </div>
      </div>
      <style jsx>{`
        .item {
          border-bottom: 1px solid ${theme.commoncolors.greyshade};
          color: ${theme.commoncolors.greycharcoal};
          font-size: 13px;
          padding: 5px 0;
          margin-left: 10px;
        }
        .wrapper {
          display: flex;
          flex-direction: row;
          gap: 10px;
          flex: 1;
          min-width: 0;
          overflow: hidden;
          align-items: flex-start;
        }
        .item-line {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 20px;
          flex-wrap: nowrap;
        }
        .title-col {
          flex: 1;
          min-width: 0;
          overflow: hidden;
        }
        .price-col {
          display: flex;
          flex-direction: row;
          min-width: 220px;
        }
        .price-row {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          justify-content: left;
          width: 100%;
          gap: 15px;
        }
        .title {
          font-weight: normal;
          font-size: 11px;
          margin-top: 0;
          margin-bottom: 0;
          white-space: normal;
          word-break: break-word;
          overflow: hidden;
        }
        .date {
          color: ${theme.commoncolors.assure};
          font-weight: bold;
          margin-bottom: 0;
          font-size: 11px;
        }
        .sub-container {
          margin-left: 10px;
        }
        .sub-label {
          font-weight: bold;
        }
        .sub-total {
          font-size: 14px;
          height: 28px;
          text-align: center;
        }
        .quantity-container {
        }
        .quantity-label {
          font-weight: bold;
        }
        .buy-button {
          display: flex;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
          padding: 6px 8px;
          font-size: 14px;
          margin-top: 2px;
          margin-left: 2px;
        }
        :global(.custom-select__select) {
          min-width: 40px !important;
          height: 22px !important;
          line-height: 1.2em !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
          font-size: 13px;
        }
        :global(.custom-select) {
          line-height: 2px !important;
          margin-left: 5px !important;
        }
        :global(.custom-select::after) {
          line-height: 2em;
          top: calc(50% - 4px) !important;
        }
        @media (max-width: 768px) {
          :global(.custom-select__select) {
            min-width: 43px !important;
            line-height: 1em !important;
            padding-top: 3px !important;
            padding-bottom: 3px !important;
          }
          :global(.custom-select__select option) {
            font-size: 10px !important;
          }
          .item-line {
            flex-direction: column;
          }
          .price-col {
            width: 84%;
            margin-left: 0px;
            flex-direction: row;
          }
          .price-row {
            justify-content: flex-start;
          }
          .wrapper {
            gap: 30px;
            flex-direction: row;
          }
          .buy-button {
            width: auto;
            font-size: 13px;
            padding: 6px 10px;
            margin-top: 6px;
          }
        }
      `}</style>
    </>
  );
};

export default VoucherValidityItem;

VoucherValidityItem.propTypes = {
  vveExtensionItem: PropTypes.object.isRequired,
};
VoucherValidityItem.propTypes = {
  bt: PropTypes.any.isRequired,
  vveExtensionItem: PropTypes.object.isRequired,
};
